import { render, staticRenderFns } from "./DesignHome.vue?vue&type=template&id=a3b9dd24&scoped=true"
import script from "./DesignHome.vue?vue&type=script&lang=js"
export * from "./DesignHome.vue?vue&type=script&lang=js"
import style0 from "./DesignHome.vue?vue&type=style&index=0&id=a3b9dd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b9dd24",
  null
  
)

/* custom blocks */
import block0 from "./DesignHome.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports